module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("For")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Bernie, Josh and Sara—my own private comedy group")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("for two people who took personal generosity")]), _vm._v(" "), _c('p', {
    staticClass: "ded-bot"
  }, [_vm._v("and professional loyalty to astounding extremes,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Christina McCall and Helga Stephenson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d39b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 66
// module chunks = 0